// PongGame.jsx
import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useMyContext } from "@/context/ContextApi";
import { useSearchParams } from "react-router-dom";
import api from "@/services/api";
import { useTranslation } from 'react-i18next';

// ----------------------------
// Game dimensions and constants
// ----------------------------
//using values for math here instead of app.css -> more stable
const GAME_WIDTH = 600;
const GAME_HEIGHT = 400;

const BALL_SIZE = 20;
const PADDLE_WIDTH = 20;
const PADDLE_HEIGHT = 100;

/* Ball speed settings */
const INITIAL_SPEED_X = 5; // starting horizontal speed
const INITIAL_SPEED_Y = 3; // starting vertical speed
const SPEED_INCREMENT = 0.5; // how much speed increases after each paddle hit
const MAX_SPEED = 20; // maximum speed the ball can reach

const LEFT_PLAYER = "PLAYER1";
const RIGHT_PLAYER = "PLAYER2";

// ----------------------------
// AI logic for single-player mode
// ----------------------------
function moveAIPaddle(paddleY, ball) {
  const paddleCenter = paddleY + PADDLE_HEIGHT / 2;
  const ballCenter = ball.y + BALL_SIZE / 2;

  // Add error
  //const errorOffset = (Math.random() - 0.5) * 40; // ±20px
  const target = ballCenter;// + errorOffset;

  const AI_SPEED = 2.4;
  if (target > paddleCenter) {
    return Math.min(paddleY + AI_SPEED, GAME_HEIGHT - PADDLE_HEIGHT);
  } else {
    return Math.max(paddleY - AI_SPEED, 0);
  }
}

// ----------------------------
// PongGame Component
// ----------------------------
const PongGame = () => {
  const { t } = useTranslation();
  //initial states - ball, paddles, game state
  const initialBallState = {
    x: 300,
    y: 200,
    speedX: INITIAL_SPEED_X, //initial horizontal speed
    speedY: INITIAL_SPEED_Y, //initial vertical speed
  };

  const initialPaddleState = { left: 150, right: 150 };

  // ----------------------------
  // React state variables
  // ----------------------------
  const [ball, setBall] = useState(initialBallState); // ball position & speed
  const [paddles, setPaddles] = useState(initialPaddleState); // paddle positions
  const [gameRunning, setGameRunning] = useState(false); // is game currently running
  const [gameOver, setGameOver] = useState(false); // is game over
  const [mode, setMode] = useState("LOCAL"); // "LOCAL" | "AI"
  const [winner, setWinner] = useState(null); // who won: "LEFT", "RIGHT", or null

  const [player2Name, setPlayer2Name] = useState("Player 2");
  const [player1Name, setPlayer1Name] = useState("Player 1");
  // const [userSide, setUserSide] = useState("LEFT"); // LEFT or RIGHT
  const winnerName =
    winner === "RIGHT"
      ? player1Name
      : winner === "LEFT"
        ? player2Name
        : null;

  const setGameMode = (newMode) => {
    setMode(newMode);
    //setGameOver(false);
    // setBall(initialBallState);
    // setPaddles(initialPaddleState);
  };

  // ----------------------------
  // Refs to hold current state for use inside interval & event handlers
  // ----------------------------
  const gameRunningRef = useRef(gameRunning);
  const modeRef = useRef(mode);
  const gameOverRef = useRef(gameOver);
  const paddlesRef = useRef(paddles);

  /**
   * SEND INFO TO BACKEND SECTION
   */

  //info about current log-in user
  const { fetchUser, currentUser, token } = useMyContext();

  //for read parametrs from url
  //based on the url sent - it gets the info (see Create Match)
  const [searchParams] = useSearchParams();

  //const mode = searchParams.get("mode");    //read mode from url

  const VALID_MODES = ["LOCAL", "AI"];

  const opponentId = searchParams.get("opponent");
  const urlMode = searchParams.get("mode");
  //const dimension = searchParams.get("dimension"); // we will use it to handle sD game
  const isAnon = searchParams.get("anon") === "true";
  const player2Type = mode === "AI" ? "AI" : isAnon ? "ANON" : "EXISTING";

  useEffect(() => {
    if (VALID_MODES.includes(urlMode)) {
      setMode(urlMode);
    } else {
      setMode("LOCAL");
    }
  }, [urlMode]);

  // useEffect(() => {
  //   if (mode === "AI"||  mode == "ANON") {
  //     setUserSide("RIGHT"); // ANON or AI always left, we always on the right
  //   }
  // }, [mode]);

  //here we set the names for the game over display in the end
  useEffect(() => {
    if (!currentUser?.username) return;

    setPlayer1Name(currentUser.username); // logged-in user

    if (mode === "AI") {
      setPlayer2Name("Computer");
    } else if (isAnon) {
      setPlayer2Name("Anonymous");
    } else if (opponentId) {
      // fetch opponent's username from backend
      api.get(`/users/${opponentId}`)
        .then((res) => {
          setPlayer2Name(res.data.username);
        })
        .catch(() => {
          setPlayer2Name("Player 2");
        });
    }
  }, [mode, opponentId, isAnon, currentUser]);

  //send match's info to backend
  useEffect(() => {
    const updateData = async () => {
      //need send - MatchMode SinglePlayer (against AI) |  Local
      //player1Id , player2Id (null for AI)
      //player1Score, player2Score
      //winnerId

      const player1Id = currentUser.id; // right
      const isAnon = searchParams.get("anon") === "true";

      let player2Id = null;

      if (mode === "LOCAL" && !isAnon && opponentId) {
        player2Id = Number(opponentId);
      }

      let player1Score = 0;
      let player2Score = 0;
      let winnerId;

      if (winner === "RIGHT") {
        winnerId = player1Id;
        player1Score = 1;
      } else {
        // winnerId = player2Id;
        player2Score = 1;
        if (mode === "AI" || mode === "ANON") {
          winnerId = null; // AI has no ID
        // } else if (isAnon) {
        //   winnerId = null; // anonymous player has no ID
        //
        } else {
          winnerId = player2Id; // real user
        }
      }

      console.log(
        "Mode game:" + mode,
        "Player 1 ID: " + player1Id,
        "Player 2 ID: " + player2Id,
        "Player 2 Type: " + player2Type,
        "Player 1 score: " + player1Score,
        "Player 2 score: " + player2Score,
        "Winner Id: " + winnerId,
      );
      //this section is for send data to backend
      try {
        await api.post("/match", {
          mode: mode,
          player1Id,
          player2Id,
          player2Type,
          player1Score,
          player2Score,
          winnerId,
        });

        //reloading user data
        //fetchUser();

        console.log("Data send to server");
      } catch (error) {
        console.log("Data send to server failed");
      }
    };

    //check if game is over, then i send data to backend
    if (gameOver) {
      console.log("Game is over!");
      console.log("Winner is: " + winner);
      updateData();
    }
  }, [gameOver, mode]);

  /**
   * END SEND INFO TO BACKEND SECTION
   */

  // Keeping refs up to date whenever state changes
  useEffect(() => {
    gameRunningRef.current = gameRunning;
  }, [gameRunning]);
  useEffect(() => {
    modeRef.current = mode;
  }, [mode]);
  useEffect(() => {
    gameOverRef.current = gameOver;
  }, [gameOver]);
  useEffect(() => {
    paddlesRef.current = paddles;
  }, [paddles]);

  // ----------------------------
  // Handle keyboard input
  // ----------------------------
  useEffect(() => {
    const handleKeyDown = (e) => {
      switch (e.key) {
        case "Enter":
          if (gameOverRef.current) {
            setBall(initialBallState);
            setPaddles(initialPaddleState);
            setGameOver(false);
          }
          setGameRunning(true);
          break;

        case " ":
          // Space resets the game completely
          setBall(initialBallState);
          setPaddles(initialPaddleState);
          setGameOver(false);
          setGameRunning(false);
          break;
        case "p":
          setGameRunning(false);
          break;
        case "ArrowUp":
          if (gameRunningRef.current) {
            setPaddles((p) => ({
              ...p,
              right: Math.max(p.right - 10, 0),
            }));
          }
          break;
        case "ArrowDown":
          if (gameRunningRef.current) {
            setPaddles((p) => ({
              ...p,
              right: Math.min(p.right + 10, GAME_HEIGHT - PADDLE_HEIGHT),
            }));
          }
          break;
        case "w":
          if (gameRunningRef.current && modeRef.current === "LOCAL") {
            setPaddles((p) => ({
              ...p,
              left: Math.max(p.left - 10, 0),
            }));
          }
          break;
        case "s":
          if (gameRunningRef.current && modeRef.current === "LOCAL") {
            setPaddles((p) => ({
              ...p,
              left: Math.min(p.left + 10, GAME_HEIGHT - PADDLE_HEIGHT),
            }));
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []); // only once

  // ----------------------------
  // Main game loop (updates every 50ms)
  // ----------------------------
  useEffect(() => {
    if (!gameRunning) return; // only run when game is active

    const intervalId = setInterval(() => {
      setBall((prev) => {
        // update ball position
        let x = prev.x + prev.speedX;
        let y = prev.y + prev.speedY;
        // current ball speed
        let speedX = prev.speedX;
        let speedY = prev.speedY;

        // Ball bounds
        const ballLeft = x;
        const ballRight = x + BALL_SIZE;

        // ----------------------------
        // Ball collision with top/bottom walls
        // ----------------------------
        if (y <= 0) {
          y = 0; //when ball touches upper wall - correct position
          speedY = Math.abs(speedY); //the ball moves down
        }
        if (y + BALL_SIZE >= GAME_HEIGHT) {
          y = GAME_HEIGHT - BALL_SIZE; //when ball touches lower wall - correct position
          speedY = -Math.abs(speedY); //the ball moves up
        }

        // ----------------------------
        // Paddle positions & collision detection
        // ----------------------------
        // Left paddle bounds

        const currentPaddles = paddlesRef.current;

        const leftPaddleLeft = 0;
        const leftPaddleRight = PADDLE_WIDTH;

        const leftPaddleTop = currentPaddles.left;
        const leftPaddleBottom = currentPaddles.left + PADDLE_HEIGHT;

        // Right paddle bounds
        const rightPaddleLeft = GAME_WIDTH - PADDLE_WIDTH;
        const rightPaddleRight = GAME_WIDTH;

        const rightPaddleTop = currentPaddles.right;
        const rightPaddleBottom = currentPaddles.right + PADDLE_HEIGHT;

        // Ball collision with left paddle
        if (
          ballLeft <= leftPaddleRight &&
          ballRight >= leftPaddleLeft &&
          y + BALL_SIZE >= leftPaddleTop &&
          y <= leftPaddleBottom
        ) {
          speedX = Math.min(Math.abs(speedX) + SPEED_INCREMENT, MAX_SPEED);
          x = leftPaddleRight; // push ball out of paddle
        }

        // Ball collision with right paddle
        if (
          ballRight >= rightPaddleLeft &&
          ballLeft <= rightPaddleRight &&
          y + BALL_SIZE >= rightPaddleTop &&
          y <= rightPaddleBottom
        ) {
          speedX = -Math.min(Math.abs(speedX) + SPEED_INCREMENT, MAX_SPEED);
          x = rightPaddleLeft - BALL_SIZE; // push ball out of paddle
        }

        // ----------------------------
        // AI movement (single-player mode)
        // ----------------------------
        if (modeRef.current === "AI") {
          setPaddles((p) => {
            const currentLeft = paddlesRef.current.left; // current AI paddle position
            const newLeft = moveAIPaddle(currentLeft, { x, y, speedX, speedY });
            paddlesRef.current.left = newLeft; // update ref for next interval
            return { ...p, left: newLeft };
          });
        }

        // Game over
        if (x < 0) {
          // Ball went past left paddle — right side wins
          setWinner("RIGHT");
          setGameOver(true);
          setGameRunning(false);
        } else if (x + BALL_SIZE > GAME_WIDTH) {
          // Ball went past right paddle — left side wins
          setWinner("LEFT");
          setGameOver(true);
          setGameRunning(false);
        }

        // return updated ball state
        return { ...prev, x, y, speedX, speedY };
      });
    }, 50);

    return () => {
      clearInterval(intervalId);
    };
  }, [gameRunning]); //function run each time one of these values changes

  // ----------------------------
  // Control buttons handlers
  // ----------------------------
  const startGame = () => {
    if (gameOver) {
      setBall(initialBallState);
      setPaddles(initialPaddleState);
      setGameOver(false);
    }
    setGameRunning(true);
  };

  const pauseGame = () => setGameRunning(false);

  const restartGame = () => {
    setBall(initialBallState);
    setPaddles(initialPaddleState);
    setGameRunning(false);
    setGameOver(false);
  };

  // ----------------------------
  // JSX rendering
  // ----------------------------
  return (
    <>
      {/* Controls above the game */}
      <div className="controls">
        <button onClick={startGame}>{t('pongGame_start')}</button>
        <button onClick={pauseGame}>{t('pongGame_pause')}</button>
        <button onClick={restartGame}>{t('pongGame_restart')}</button>
      </div>

      <div className="controls-info">
        {t('pongGame_controls')}
      </div>

      {/* Player names scoreboard */}
      <div style={{ width: GAME_WIDTH }} className="mx-auto flex items-center justify-between mb-3 px-2">
        <div className="flex items-center gap-2">
          <div className="w-1 h-6 rounded-full bg-violet-500" />
          <span className="text-sm font-semibold text-white tracking-wide truncate max-w-[200px]">
            {player2Name}
            {/* {t('IT"S LEFT SIDE')}  */}
          </span>
        </div>
        <span className="text-sm font-mono uppercase tracking-widest text-zinc-400">vs</span>
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-white tracking-wide truncate max-w-[200px] text-right">
            {player1Name}
          </span>
          <div className="w-1 h-6 rounded-full bg-violet-500" />
        </div>
      </div>

      {/* Game area */}
      <div className="mx-auto" style={{ width: GAME_WIDTH }}>
        <div
          className="ping-pong-container"
          style={{ width: GAME_WIDTH, height: GAME_HEIGHT }}
        >
          {/* Left Paddle */}
          <div
            className="paddle"
            style={{
              position: "absolute",
              width: PADDLE_WIDTH,
              height: PADDLE_HEIGHT,
              top: paddles.left,
              left: 0,
            }}
          />

          {/* Right Paddle */}
          <div
            className="paddle"
            style={{
              position: "absolute",
              width: PADDLE_WIDTH,
              height: PADDLE_HEIGHT,
              top: paddles.right,
              right: 0,
            }}
          />

          {/* Ball */}
          <div
            className="ball"
            style={{
              position: "absolute",
              width: BALL_SIZE,
              height: BALL_SIZE,
              borderRadius: "50%",
              left: ball.x,
              top: ball.y,
            }}
          />
          {/* Game over overlay */}
          {gameOver && (
            <div className="game-over">
              <div>{t('pongGame_gameOver')}</div>
              {winnerName && <div>{winnerName} {t('pongGame_wins')}</div>}
            </div>
          )}
        </div>
      </div>

      {/* Controls under the game */}
    </>
  );
};

export default PongGame;
